import { generatePath } from "react-router-dom"

import { paths } from "@src/app/paths"
import { router } from "@src/pages"
import { TourStepBase } from "@src/widgets/onboarding/classes/TourStepBase"
import {
  ONBOARDING_TOURS,
  TOUR_MODAL_PLACEMENTS,
} from "@src/widgets/onboarding/types"
import { CheckoutsCreateStepUi } from "@src/widgets/onboarding/ui/tours/CryptoPayments/steps/CheckoutsCreateStepUi"
import { OnboardingStepComponentWrapProps } from "@src/widgets/onboarding/ui/tours/OnboardingStepComponentWrap"

export class CheckoutsCreateStep extends TourStepBase {
  component = CheckoutsCreateStepUi
  name = `${ONBOARDING_TOURS.CRYPTO_PAYMENTS}_CheckoutsCreate`

  constructor() {
    super({ placement: TOUR_MODAL_PLACEMENTS.BOTTOM_RIGHT })
  }

  action() {
    return router.navigate({
      pathname: generatePath(paths.checkout, { id: "new" }),
    })
  }

  popupProps(): Omit<OnboardingStepComponentWrapProps, "children"> {
    return {
      pic: this.name,
      subtitle: "Create your custom HTML iFrame integration",
      title: "Accepting Cryptocurrency Payments",
    }
  }
}
